export const getLanguageDisplayName = (languageCode: string): string => {
  try {
    const parts = languageCode.split('-');

    if (parts.length === 2) {
      const [lang, region] = parts;
      const languageDisplayNames = new Intl.DisplayNames(['en'], { type: 'language' });
      const regionDisplayNames = new Intl.DisplayNames(['en'], { type: 'region' });

      const languageName = languageDisplayNames.of(lang);
      const regionName = regionDisplayNames.of(region);

      if (languageName && regionName) {
        return `${languageName} (${regionName})`;
      }
    }

    const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
    return displayNames.of(languageCode) || languageCode;
  } catch {
    return languageCode;
  }
};
